import { Box, Button } from "@mui/material";
import { ReactNode } from "react";
import { ChevronSmallRightIcon } from "@/components/common/icons";
import { GREY } from "@/config/mui/colorPalette";
import OutlinedButton from "../buttons/outlinedButton";

type Props = {
  url?: string;
  showButton?: boolean;
  children: ReactNode;
};

export default function FormRowLink({
  url,
  showButton = false,
  children,
}: Props) {
  if (!url) {
    /**
     * If url is not present, we don't want to render a link.
     * We will render the children as is.
     */
    return <Box sx={{ py: 1 }}>{children}</Box>;
  }
  return (
    <Button
      aria-label="Click to see form details"
      sx={{
        p: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        width: "100%",
        svg: {
          flexShrink: 0,
        },
        py: 1,
      }}
      href={url}
    >
      {children}
      {showButton ? (
        <OutlinedButton
          text="Complete form"
          small
          sx={{
            mb: 0,
            borderRadius: "12px",
            minWidth: "fit-content",
          }}
          link={url}
          withIcon={false}
        />
      ) : (
        <ChevronSmallRightIcon
          color={GREY[50]}
          style={{ alignSelf: "flex-start" }}
        />
      )}
    </Button>
  );
}
